import React, { useContext, useState } from "react";
import UniversalEditableGrid from "../../../../CommonComponents/Grid/EditableGrid/UniversalEditableGrid";
import { OrderContext } from "../Contex";
import { itemGridFields } from "./ItemGridFields";
import Button from "react-bootstrap/Button";
import * as _ from "underscore";
import ItemDetails from "./ItemsDetails/Index";
function Items(props) {
  const { _orderData, operation, _setOrderData, dropDowns } =
    useContext(OrderContext);
  const [showItemsDetailsModal, setShowItemsDetailsModal] = useState(false);
  const [itemOperation, setItemOperation] = useState();
  const [item, setItem] = useState({});

  const addNewItemClick = () => {
    let maxItemNumber = 0;
    let itemNumbers = [];

    if (_orderData.orderItemsComm != null) {
      _orderData.orderItemsComm.forEach((arrayItem) => {
        itemNumbers.push(arrayItem.itemNumber);
      });
      maxItemNumber = _.max(itemNumbers);
    }

    if (maxItemNumber === -Infinity || maxItemNumber === 0) {
      maxItemNumber = 10;
    } else {
      maxItemNumber = maxItemNumber + 10;
    }

    let newItemObject = {
      itemNumber: maxItemNumber,
    };
    setItemOperation("Create");
    setShowItemsDetailsModal(true);
    setItem({ ...newItemObject });
  };
  //Grid functions handler
  function handleButtonClickGrid(e) {
    let selectedItemNumber = e.target.dataset.id;
    let gridButtonOperation = e.target.dataset.op;
    let result;
    let currentItems = _orderData.orderItemsComm;

    setItemOperation(gridButtonOperation);
    switch (gridButtonOperation) {
      case "Display":
      case "Change":
        result = _orderData.orderItemsComm.find(
          ({ itemNumber }) => +itemNumber === +selectedItemNumber
        );
        setItem(result);
        setShowItemsDetailsModal(true);
        break;
      case "Delete":
        currentItems = currentItems.filter(
          (x) => +x.itemNumber !== +selectedItemNumber
        );
        _setOrderData((current) => {
          return { ...current, shippingDocItemsComm: currentItems };
        });
        break;

      default:
    }
  }
  //Acccpte chnages from item details window
  const handleAccept = () => {
    if (itemOperation === "Create") {
      _setOrderData((current) => {
        let items = current.orderItemsComm || [];

        items.push(item);
        return { ...current, orderItemsComm: items };
      });
    } else {
      _setOrderData((current) => {
        let items = current.orderItemsComm;

        var index = items.findIndex((x) => x.itemNumber === item.itemNumber);
        if (index >= 0) {
          items[index] = item;
        }
        return { ...current, orderItemsComm: items };
      });
    }
  };
  
  //Update main state, update item data
  const onChangeItem = (e) => {
    
    let item;
    let fieldTypeItem;
    const {
      target: { value, name },
    } = e;

    item = e.target.dataset.item;
    //Get field type from  from custom attribute, this used for select mainly
    fieldTypeItem = e.target.dataset.type;

    let newValue;
    switch (fieldTypeItem) {
      case "number":
        newValue = Number(value);
        break;
      default:
        newValue = value;
        break;
    }
    const newValueObject = { [name]: newValue };

    let newItems = _orderData.orderItemsComm.map((i) => {
      //Did not use === becuase '5' equals to 5
      if (i.itemNumber == item) {
        return { ...i, ...newValueObject };
      }
      return i;
    });
    _setOrderData((prevState) => {
      return { ...prevState, orderItemsComm: newItems };
    });
  };

  if (showItemsDetailsModal) {
    return (
      <div className="mt-4">
        <ItemDetails
          setShowItemsDetailsModal={setShowItemsDetailsModal}
          itemOperation={itemOperation}
          item={item}
          setItem={setItem}
          handleAccept={handleAccept}
        />
      </div>
    );
  }
  return (
    <div>
      <Button
        variant="primary"
        active="true"
        data-op="Create"
        disabled={operation === "Display"}
        onClick={addNewItemClick}
      >
        Add New Item
      </Button>

      <UniversalEditableGrid
        fields={itemGridFields}
        headerData={_orderData}
        itemData={_orderData?.orderItemsComm ?? []}
        dropDowns={dropDowns}
        operation={operation}
        onChange={onChangeItem}
        handleButtonClickGrid={handleButtonClickGrid}
        ActionColumn={true}
      />
    </div>
  );
}

export default Items;
